// extracted by mini-css-extract-plugin
export default {"feedBox":"index_feedBox_duOD5","feed":"index_feed_AvXOH","feedImage":"index_feedImage_10MTV","feedText":"index_feedText_9qy-w","clearfix":"index_clearfix_2-SrF"};